var X = Object.defineProperty;
var W = Object.getOwnPropertySymbols;
var Z = Object.prototype.hasOwnProperty, Q = Object.prototype.propertyIsEnumerable;
var j = (e, t, n) => t in e ? X(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, V = (e, t) => {
  for (var n in t || (t = {}))
    Z.call(t, n) && j(e, n, t[n]);
  if (W)
    for (var n of W(t))
      Q.call(t, n) && j(e, n, t[n]);
  return e;
};
var P = (e, t, n) => new Promise((s, i) => {
  var d = (l) => {
    try {
      u(n.next(l));
    } catch (c) {
      i(c);
    }
  }, p = (l) => {
    try {
      u(n.throw(l));
    } catch (c) {
      i(c);
    }
  }, u = (l) => l.done ? s(l.value) : Promise.resolve(l.value).then(d, p);
  u((n = n.apply(e, t)).next());
});
import { defineComponent as ee, cloneVNode as te } from "vue";
const ne = () => ({
  /**
   *  Class to pass to the print window body
   */
  bodyClass: {
    type: String,
    default: ""
  },
  /**
   *  Content to be printed
   */
  content: {
    type: Function,
    required: !0
  },
  /**
   *  Copy styles over into print window. default: true
   */
  copyStyles: {
    type: Boolean,
    default: !0
  },
  /**
   * Set the title for printing when saving as a file.
   * Will result in the calling page's `<title>` being temporarily changed while printing.
   */
  documentTitle: {
    type: String,
    default: ""
  },
  /**
   *  Pre-load these fonts to ensure availability when printing
   */
  fonts: {
    type: Array,
    default: () => []
  },
  /**
   *  Callback function to trigger after print
   */
  onAfterPrint: {
    type: Function,
    default: null
  },
  /**
   *  Callback function to trigger before page content is retrieved for printing
   */
  onBeforeGetContent: {
    type: Function,
    default: null
  },
  /**
   *  Callback function to trigger before print
   */
  onBeforePrint: {
    type: Function,
    default: null
  },
  /**
   *  Callback function to listen for printing errors
   */
  onPrintError: {
    type: Function,
    default: null
  },
  /**
   *  Override default print window styling
   */
  pageStyle: {
    type: [String, Function],
    default: `
        @page {
            /* Remove browser default header (title) and footer (url) */
            margin: 0;
        }
        @media print {
            body {
                /* Tell browsers to print background colors */
                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */
                color-adjust: exact; /* Firefox */
            }
        }
    `
  },
  /**
   *  Override the default `window.print` method that is used for printing
   */
  print: {
    type: Function,
    default: null
  },
  /**
   * Remove the iframe after printing.
   * NOTE: `onAfterPrint` will run before the iframe is removed
   */
  removeAfterPrint: {
    type: Boolean,
    default: !1
  },
  /**
   *  Suppress error messages
   */
  suppressErrors: {
    type: Boolean,
    default: !1
  },
  /**
   *  Set the nonce attribute for whitelisting script and style -elements for CSP (content security policy)
   */
  nonce: {
    type: String,
    default: ""
  },
  contextSlots: {
    type: Object
  }
});
function O(e) {
  return !!e.shadowRoot;
}
let B = !1;
function oe() {
  if (B)
    return;
  class e extends HTMLElement {
    constructor() {
      super(), this.attachShadow({ mode: "open" });
    }
  }
  customElements.define("vue-to-print-shadow-dom", e), B = !0;
}
const se = `
  class VueToPrintShadowDom extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
    }
  }
  customElements.define('vue-to-print-shadow-dom', VueToPrintShadowDom);
`;
function re(e) {
  const t = e.createElement("script");
  t.setAttribute("type", "text/javascript"), t.setAttribute("vue-to-print-custom-script", "registry-shadow-dom"), t.innerHTML = se, e.body.appendChild(t);
}
const ie = `
  function retrieveStyleSheets(styleSheetMap) {
    styleSheetMap.forEach((styleSheetStrings, tagName) => {
      const styleSheets = [];
      for (let i = styleSheetStrings.length; i--;) {
        const styleSheet = new CSSStyleSheet();
        styleSheet.replaceSync(styleSheetStrings[i]);
        styleSheets.push(styleSheet);
      }

      const elements = document.querySelectorAll('vue-to-print-shadow-dom[original-tag-name=' + tagName + ']');
      for (let i = elements.length; i--;) {
        const element = elements[i];
        element.shadowRoot.adoptedStyleSheets = styleSheets;
      }
    });
  }
`;
function le(e) {
  const t = e.createElement("script");
  t.setAttribute("type", "text/javascript"), t.setAttribute("vue-to-print-custom-script", "registry-retrieve-style-sheets-func"), t.innerHTML = ie, e.body.appendChild(t);
}
const L = /* @__PURE__ */ new Map();
function I(e) {
  oe();
  const t = e.nodeName.toLowerCase(), s = e.shadowRoot.adoptedStyleSheets, i = document.createElement("vue-to-print-shadow-dom");
  i.setAttribute("original-tag-name", t), L.has(t) || L.set(t, /* @__PURE__ */ new Set());
  const d = L.get(t);
  for (let l = s.length; l--; )
    d.add(s[l]);
  const p = i.attributes, u = e.attributes;
  for (let l = u.length; l--; )
    p.setNamedItem(u[l].cloneNode());
  return i;
}
function ce() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = Array.from(L.keys());
  for (let s = n.length; s--; ) {
    const i = [], d = n[s], p = Array.from(L.get(d));
    for (let u = p.length; u--; ) {
      const l = p[u];
      if (!t.has(l)) {
        let c = "";
        const o = Array.from(l.cssRules);
        for (let r = o.length; r--; )
          c += o[r].cssText;
        t.set(l, c);
      }
      i.push(t.get(l));
    }
    e.set(d, i);
  }
  return e;
}
function ae(e) {
  const t = e.contentWindow || null;
  if (!t)
    throw new Error("Cannot access print window");
  const n = t.document;
  if (!n)
    throw new Error("Cannot access print document");
  re(n), le(n);
  const s = ce();
  t.retrieveStyleSheets(s);
}
function H(e) {
  return !!customElements.get(e.nodeName.toLowerCase());
}
let _ = !1;
function ue() {
  if (_)
    return;
  class e extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define("vue-to-print-custom-element", e), _ = !0;
}
function $(e) {
  ue();
  const t = e.nodeName.toLowerCase(), n = document.createElement("vue-to-print-custom-element");
  n.setAttribute("original-tag-name", t);
  const s = n.attributes, i = e.attributes;
  for (let d = i.length; d--; )
    s.setNamedItem(i[d].cloneNode());
  return n;
}
function Y(e) {
  return P(this, null, function* () {
    e.getAttribute("src") && (e.complete || (yield new Promise((t, n) => {
      e.addEventListener("load", t, { once: !0 }), e.addEventListener("error", (s) => n(s.error), {
        once: !0
      });
    })));
  });
}
function de(e) {
  return P(this, null, function* () {
    e.readyState >= 2 || (yield new Promise((t, n) => {
      e.addEventListener("loadeddata", t, { once: !0 }), e.addEventListener("error", (s) => n(s.error), {
        once: !0
      }), e.addEventListener("stalled", () => n(new Error("Loading video stalled, skipping")), {
        once: !0
      });
    }));
  });
}
function he(e) {
  const t = e.cloneNode(), n = t.getContext("2d");
  return n && n.drawImage(e, 0, 0), t;
}
function fe(e, t) {
  const n = e.cloneNode();
  return t.push(Y(n)), n;
}
function pe(e, t) {
  const n = e.cloneNode();
  n.preload = "auto";
  const s = n.getAttribute("poster");
  if (s) {
    const i = new Image();
    i.src = s, t.push(Y(i));
  } else
    t.push(de(n));
  return n;
}
function me(e) {
  const t = e.cloneNode();
  switch (e.type) {
    case "checkbox":
    case "radio":
      t.checked = e.checked;
      break;
    default:
      t.value = e.value;
      break;
  }
  return t;
}
function ye(e) {
  const t = e.cloneNode();
  return t.value = e.value, t;
}
function ge(e) {
  const t = e.cloneNode();
  return t.selected = e.selected, t;
}
const q = /* @__PURE__ */ new Map([
  ["canvas", he],
  ["img", fe],
  ["video", pe],
  ["input", me],
  ["select", ye],
  ["option", ge]
]);
function we(e) {
  return e.cloneNode();
}
function be(e, t = []) {
  const n = e.nodeName.toLowerCase();
  return (q.has(n) ? q.get(n) : we)(e, t);
}
function Se(e) {
  var n;
  if (e.nodeName.toLowerCase() === "slot") {
    const s = e.assignedNodes();
    return s.length > 0 ? s : Array.from(e.childNodes);
  } else
    return Array.from(((n = e.shadowRoot) != null ? n : e).childNodes);
}
function Ee(e) {
  return P(this, null, function* () {
    const t = /* @__PURE__ */ new Map(), n = [];
    let s;
    O(e) ? s = I(e) : H(e) ? s = $(e) : s = e.cloneNode(), t.set(e, s);
    const i = [e];
    for (; i.length; ) {
      const d = i.shift(), p = Se(d);
      if (p.length <= 0)
        continue;
      const u = t.get(d), l = O(u) ? u.shadowRoot : u;
      for (let c = 0; c < p.length; c++) {
        const o = p[c];
        let r;
        O(o) ? r = I(o) : H(o) ? r = $(o) : r = be(o, n), t.set(o, r), i.push(o), l.appendChild(r);
      }
    }
    return yield Promise.all(n), s;
  });
}
const ve = {
  copyStyles: !0,
  pageStyle: `
        @page {
            /* Remove browser default header (title) and footer (url) */
            margin: 0;
        }
        @media print {
            body {
                /* Tell browsers to print background colors */
                -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */
                color-adjust: exact; /* Firefox */
            }
        }
    `,
  removeAfterPrint: !1,
  suppressErrors: !1
};
function Ce(e) {
  e = V(V({}, ve), e);
  let t = 0, n = [], s = [];
  const i = (o) => {
    const { onAfterPrint: r, onPrintError: h, print: m, documentTitle: b } = e;
    setTimeout(() => {
      var S, T;
      if (o.contentWindow)
        if (o.contentWindow.focus(), m)
          m(o).then(() => r == null ? void 0 : r()).then(() => l()).catch((a) => {
            h ? h("print", a) : c(["An error was thrown by the specified `print` function"]);
          });
        else {
          if (o.contentWindow.print) {
            const a = (T = (S = o.contentDocument) == null ? void 0 : S.title) != null ? T : "", D = o.ownerDocument.title;
            b && (o.ownerDocument.title = b, o.contentDocument && (o.contentDocument.title = b)), o.contentWindow.print(), b && (o.ownerDocument.title = D, o.contentDocument && (o.contentDocument.title = a));
          } else
            c([
              "Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."
            ]);
          r == null || r(), l();
        }
      else
        c([
          "Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `vue-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"
        ]);
    }, 500);
  }, d = (o) => {
    const { onBeforePrint: r, onPrintError: h } = e;
    if (r) {
      const m = r();
      m && typeof m.then == "function" ? m.then(() => {
        i(o);
      }).catch((b) => {
        h && h("onBeforePrint", b);
      }) : i(o);
    } else
      i(o);
  }, p = () => {
    const { onBeforeGetContent: o, onPrintError: r } = e;
    if (o) {
      const h = o();
      h && typeof h.then == "function" ? h.then(u).catch((m) => {
        r && r("onBeforeGetContent", m);
      }) : u();
    } else
      u();
  }, u = () => P(this, null, function* () {
    const { bodyClass: o, content: r, copyStyles: h, fonts: m, pageStyle: b, nonce: S } = e, T = r();
    if (T === void 0) {
      c([
        "To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"
      ]);
      return;
    }
    if (T === null) {
      c([
        'There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "vue-to-print" to be called.'
      ]);
      return;
    }
    const a = document.createElement("iframe");
    a.width = `${document.documentElement.clientWidth}px`, a.height = `${document.documentElement.clientHeight}px`, a.style.position = "absolute", a.style.top = `-${document.documentElement.clientHeight + 100}px`, a.style.left = `-${document.documentElement.clientWidth + 100}px`, a.id = "printWindow", a.srcdoc = "<!DOCTYPE html>";
    const D = T;
    if (!D) {
      c([
        '"vue-to-print" could not locate the DOM node corresponding with the `content` prop'
      ]);
      return;
    }
    const z = yield Ee(D), U = document.querySelectorAll("link[rel~='stylesheet']"), J = m ? m.length : 0;
    t = U.length + J, n = [], s = [];
    const C = (f, A) => {
      if (n.includes(f)) {
        c(["Tried to mark a resource that has already been handled", f], "debug");
        return;
      }
      A ? (c([
        '"vue-to-print" was unable to load a resource but will continue attempting to print the page',
        ...A
      ]), s.push(f)) : n.push(f), n.length + s.length === t && d(a);
    };
    a.onload = () => P(this, null, function* () {
      var A, R;
      a.onload = null;
      const f = a.contentDocument || ((A = a.contentWindow) == null ? void 0 : A.document);
      if (f) {
        f.body.appendChild(z), m && ((R = a.contentDocument) != null && R.fonts && typeof FontFace != "undefined" ? m.forEach((y) => {
          const E = new FontFace(y.family, y.source, {
            weight: y.weight,
            style: y.style
          });
          a.contentDocument.fonts.add(E), E.loaded.then(() => {
            C(E);
          }).catch((F) => {
            C(E, [
              "Failed loading the font:",
              E,
              "Load error:",
              F
            ]);
          });
        }) : (m.forEach((y) => C(y)), c([
          '"vue-to-print" is not able to load custom fonts because the browser does not support the FontFace API but will continue attempting to print the page'
        ])));
        const M = typeof b == "function" ? b() : b;
        if (typeof M != "string")
          c([
            `"vue-to-print" expected a "string" from \`pageStyle\` but received "${typeof M}". Styles from \`pageStyle\` will not be applied.`
          ]);
        else {
          const y = f.createElement("style");
          S && (y.setAttribute("nonce", S), f.head.setAttribute("nonce", S)), y.appendChild(f.createTextNode(M)), f.head.appendChild(y);
        }
        if (o && f.body.classList.add(...o.split(" ")), h) {
          const y = document.querySelectorAll("style, link[rel~='stylesheet']");
          for (let E = 0, F = y.length; E < F; ++E) {
            const g = y[E];
            if (g.tagName.toLowerCase() === "style") {
              const w = f.createElement(g.tagName), v = g.sheet;
              if (v) {
                let k = "";
                try {
                  const N = v.cssRules.length;
                  for (let x = 0; x < N; ++x)
                    typeof v.cssRules[x].cssText == "string" && (k += `${v.cssRules[x].cssText}\r
`);
                } catch (N) {
                  c(
                    [
                      "A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",
                      g
                    ],
                    "warning"
                  );
                }
                w.setAttribute("id", `vue-to-print-${E}`), S && w.setAttribute("nonce", S), w.appendChild(f.createTextNode(k)), f.head.appendChild(w);
              }
            } else if (g.getAttribute("href"))
              if (g.hasAttribute("disabled"))
                c(
                  [
                    "`vue-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",
                    g
                  ],
                  "warning"
                ), C(g);
              else {
                const w = f.createElement(g.tagName);
                for (let v = 0, k = g.attributes.length; v < k; ++v) {
                  const N = g.attributes[v];
                  N && w.setAttribute(N.nodeName, N.nodeValue || "");
                }
                w.onload = () => C(w), w.onerror = (v, k, N, x, K) => C(w, ["Failed to load", w, "Error:", K]), S && w.setAttribute("nonce", S), f.head.appendChild(w);
              }
            else
              c(
                [
                  "`vue-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",
                  g
                ],
                "warning"
              ), C(g);
          }
        }
      }
      ae(a), (t === 0 || !h) && d(a);
    }), l(!0), document.body.appendChild(a);
  }), l = (o) => {
    const { removeAfterPrint: r } = e;
    if (o || r) {
      const h = document.getElementById("printWindow");
      h && document.body.removeChild(h);
    }
  }, c = (o, r = "error") => {
    const { suppressErrors: h } = e;
    h || (r === "error" ? console.error(o) : r === "warning" ? console.warn(o) : r === "debug" && console.debug(o));
  };
  return {
    handlePrint: p
  };
}
const Ne = /* @__PURE__ */ ee({
  name: "VueToPrint",
  props: ne(),
  setup(e, {
    slots: t,
    expose: n
  }) {
    const {
      handlePrint: s
    } = Ce(e);
    return n({
      handlePrint: s
    }), () => {
      const {
        default: i,
        trigger: d
      } = t;
      if (d)
        return d().map((u) => te(u, {
          onClick: s
        }));
      {
        const p = {
          handlePrint: s
        };
        return i == null ? void 0 : i(p);
      }
    };
  }
}), G = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VueToPrint: Ne
}, Symbol.toStringTag, { value: "Module" })), Te = function(e) {
  Object.keys(G).forEach((n) => {
    const s = G[n];
    e.use(Pe(s));
  });
};
function Pe(e) {
  return {
    install: (t) => {
      const n = e.name;
      if (typeof n != "string" || n.length <= 0)
        throw new Error("Component name is required");
      t.component(n, e);
    }
  };
}
const xe = {
  install: Te
};
export {
  Ne as VueToPrint,
  xe as default,
  Ce as useVueToPrint,
  ne as vueToPrintProps
};
